/**
 * usePagedSearch — hook para busca + paginação client-side.
 *
 * @param {Array} items - lista completa
 * @param {(item, q) => boolean} matches - filtro por termo (opcional; default: filtra por `name`)
 * @param {number} pageSize - itens por página (default 10)
 *
 * Retorna: { q, setQ, page, setPage, totalPages, total, pageItems, resetPage }
 */
import { useMemo, useState } from "react";

const defaultMatches = (item, q) => {
  if (!q) return true;
  const s = q.toLowerCase().trim();
  const hay = String(item?.name || "").toLowerCase();
  return hay.includes(s);
};

export function usePagedSearch(items, options = {}) {
  const { matches = defaultMatches, pageSize = 10 } = options;
  const [q, setQRaw] = useState("");
  const [page, setPage] = useState(1);

  const setQ = (v) => { setQRaw(v); setPage(1); };

  const filtered = useMemo(() => {
    const list = Array.isArray(items) ? items : [];
    if (!q) return list;
    return list.filter((it) => matches(it, q));
  }, [items, q, matches]);

  const total = filtered.length;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const safePage = Math.min(page, totalPages);
  const start = (safePage - 1) * pageSize;
  const pageItems = filtered.slice(start, start + pageSize);
  const resetPage = () => setPage(1);

  return { q, setQ, page: safePage, setPage, totalPages, total, pageItems, resetPage };
}
